import SkeletonLoaderCard from "./SkeletonLoaderCard";
import React from "react";
import SkeletonLoaderCardSlim from "./SkeletonLoaderCardSlim";

export function SkeletonLoaderWrapper({ children, className, style, slim = false, LoaderComponent = slim ? SkeletonLoaderCardSlim : SkeletonLoaderCard, loading, loadingMinHeight, loadingMinWidth }) {
    let thisStyle = style;
    if (loading && loadingMinHeight) {
        thisStyle = {
            ...style,
            minHeight: loadingMinHeight,
            minWidth: loadingMinWidth,
        };
    }
    return (
        <div className={className} style={{ ...thisStyle, position: "relative" }}>
            {loading ? <div style={{ visibility: "hidden" }}>{children}</div> : children}
            {loading && <LoaderComponent border={true} />}
        </div>
    );
}
